'use client'
import React, { HTMLAttributes, ReactNode, useEffect, useRef } from 'react'

type DangerouslySetHtmlContentProps = {
  html: string | React.ReactNode
} & HTMLAttributes<HTMLDivElement>

export const DangerouslySetHtmlContent = ({
  html,
  ...rest
}: DangerouslySetHtmlContentProps): ReactNode => {
  // Hack for explicit trigger of instagram & twitter embeds
  // TODO : could probably add check if either is even in content of news
  // TODO : does this respect consent manager?

  //   useEffect(() => {
  //     const instagramScript = document.createElement('script')
  //     instagramScript.setAttribute('src', 'https://www.instagram.com/embed.js')
  //     instagramScript.setAttribute('async', 'true')
  //     document.head.appendChild(instagramScript)
  //     // @ts-ignore
  //     window?.instgrm?.Embeds?.process()

  //     const twitterScript = document.createElement('script')
  //     twitterScript.setAttribute('src', 'https://platform.twitter.com/widgets.js')
  //     twitterScript.setAttribute('async', 'true')
  //     document.head.appendChild(twitterScript)
  //   }, [])

  if (React.isValidElement(html)) {
    return html
  } else {
    return <HtmlFragment {...rest} html={html as string} />
  }
}

type HtmlFragmentProps = {
  html: string
} & HTMLAttributes<HTMLDivElement>

export const HtmlFragment = ({
  html,
  ...rest
}: HtmlFragmentProps): ReactNode => {
  const ref = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (!html) return

    try {
      const slotHtml = document.createRange().createContextualFragment(html) // Create a 'tiny' document and parse the html string
      if (ref.current !== null) {
        ref.current.innerHTML = '' // Clear the container
        ref.current.appendChild(slotHtml) // Append the new content
      }
    } catch (e) {
      console.error(e)
    }
  }, [html])
  return <div {...rest} ref={ref}></div>
}
